import { useState, useEffect } from 'react';
import axios from 'axios';
import styles from './sportstaettenManagement.module.css';
import defaultStyles from '../default.module.css';
import SportstaetteForm from './SportstaetteForm';
import SportstaetteCard from './SportstaetteCard';
import { Icons } from '../../../../code/IconHandler';
import { showErrorToast } from '../../../../code/ToastHelper';
export default function SportstaettenManagement() {
    const [sportstaetten, setSportstaetten] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editingSportstaette, setEditingSportstaette] = useState(null);
    const [loading, setLoading] = useState(false);

    const token = localStorage.getItem('token');



    const fetchSportstaetten = async () => {
        setLoading(true);
        try {
            const res = await axios.get('/api/sportstaetten', {
                headers: { Authorization: `Bearer ${token}` }
            });

            // Sort by combined display name
            const sorted = res.data.sort((a, b) => {
                const aDisplay = a.bezeichnung
                    ? `${a.bezeichnung} – ${a.name}`
                    : a.name;
                const bDisplay = b.bezeichnung
                    ? `${b.bezeichnung} – ${b.name}`
                    : b.name;
                return aDisplay.localeCompare(bDisplay, 'de', { sensitivity: 'base' });
            });

            setSportstaetten(sorted);
        } catch (err) {
            console.error('Fehler beim Laden:', err);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchSportstaetten();
    }, []);
    const openNewModal = () => {
        setEditingSportstaette(null);
        setShowModal(true);
    };

    const openEditModal = (item) => {
        setEditingSportstaette(item);
        setShowModal(true);
    };

    const handleSave = (id, mode) => {
        setShowModal(false);
        fetchSportstaetten();
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Wirklich löschen?')) return;
        try {
            await axios.delete(`/api/sportstaetten/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            fetchSportstaetten();
        } catch (err) {
            showErrorToast("Fehler beim Löschen der Sportstätte!")
        }
    };

    return (
        <div className={defaultStyles.container}>
            <h1>Sportstätten verwalten</h1>
            {showModal && (
                <SportstaetteForm
                    sportstaette={editingSportstaette}
                    onSave={handleSave}
                    onClose={() => setShowModal(false)}
                />
            )}

            <div className={defaultStyles.titleButton}>
                <h2>Bestehende Sportstätten</h2>
                <button className={defaultStyles.blueButton} onClick={openNewModal}>
                    <Icons.Add /> Sportstätte
                </button>
            </div>
            {loading ? (
                <p>Lade...</p>
            ) : (
                <div className={styles.listContainer}>
                    {sportstaetten.map((s) => (
                        <SportstaetteCard
                            key={s.id}
                            sportstaette={s}
                            onEdit={openEditModal}
                            onDelete={handleDelete}
                        />
                    ))}
                </div>
            )}
        </div>
    );
}
